module.exports = __webpack_public_path__ + "img/postcard-front.6ab08526.png";